import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/redux/~/lodash-es/_getPrototype.js
// module id = 1152
// module chunks = 0